/** Microsoft Clarity for deskreplay.com marketing site only. */

let activeProjectId: string | null = null;

export function loadMicrosoftClarity(projectId: string): void {
  if (!projectId || activeProjectId === projectId) return;

  type ClarityFn = ((...args: unknown[]) => void) & { q?: unknown[] };
  const w = window as Window & { clarity?: ClarityFn };
  w.clarity =
    w.clarity ||
    function clarity(...args: unknown[]) {
      (w.clarity!.q = w.clarity!.q || []).push(args);
    };

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.clarity.ms/tag/${encodeURIComponent(projectId)}`;
  const firstScript = document.getElementsByTagName("script")[0];
  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
  } else {
    document.head.appendChild(script);
  }

  activeProjectId = projectId;
}

export function setClarityConsent(granted: boolean): void {
  if (!window.clarity) return;
  window.clarity("consent", granted);
}
